module.exports = __webpack_public_path__ + "img/sec4_6_.c3c4ded8.png";